import privateImage from "@/public/img/products/private-label/private-label.png";
import Image from "next/image";
import { m } from "framer-motion";

const PrivateLabelSection = () => {
  return (
    <section className="flex w-full bg-auto-black/5 py-16">
      <div className="container grid grid-cols-1 items-center justify-center gap-10 px-4 md:grid-cols-2">
        <div className="flex w-full flex-col items-center justify-center gap-3 py-4">
          <m.div
            className="relative aspect-video w-full"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{
              opacity: 1,
              x: 0,
              transition: { duration: 0.5, ease: "easeOut" },
            }}
            viewport={{ once: true }}
          >
            <Image
              src={privateImage}
              alt=""
              fill
              className="absolute inset-0 object-contain object-center drop-shadow-[10px_5px_7px_rgba(0,0,0,0.4)]"
              sizes="(max-width: 600px) 275px, (max-width: 900px) 375px, (max-width: 1200px) 275px, 375px"
            />
          </m.div>
        </div>
        <m.div
          className="flex w-full flex-col items-center justify-center gap-5 text-center md:items-start md:text-start"
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" },
          }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-primary-700">Private Label</h2>
          <div className="text-base font-medium leading-normal text-auto-black/60">
            We offer private label solutions for our premium frozen vegetables.
            Your brand, our quality – the perfect partnership for success.
          </div>
        </m.div>
      </div>
    </section>
  );
};

export default PrivateLabelSection;
